export default __webpack_public_path__ + "static/media/6B4_at_2020-15-2.20f76388.png";